import React from 'react'
import {
    Badge,
    Box,
    Flex,
    Popover,
    PopoverArrow,
    PopoverBody,
    PopoverCloseButton,
    PopoverContent,
    PopoverHeader,
    PopoverTrigger,
    Text,
    Tooltip,
} from '@chakra-ui/react'

const LEVEL_COLOR = {
    low: 'green',
    medium: 'orange',
    high: 'red',
}

const LEVEL_LABEL = {
    low: 'Low',
    medium: 'Medium',
    high: 'High',
}

const RiskBadge = ({score, level, factors}) => {
    if (score === null || score === undefined) {
        return (
            <Tooltip label="Risk has not been computed for this order yet" aria-label="Risk pending">
                <Text color="gray.400">—</Text>
            </Tooltip>
        )
    }

    const color = LEVEL_COLOR[level] || 'gray'
    const label = LEVEL_LABEL[level] || 'Unknown'
    const list = Array.isArray(factors) ? factors : []

    return (
        <Popover placement="right-start" isLazy>
            <PopoverTrigger>
                <Badge
                    as="button"
                    type="button"
                    colorScheme={color}
                    borderRadius="full"
                    px="2.5"
                    py="0.5"
                    fontSize="0.75em"
                    cursor="pointer"
                    onClick={(e) => e.stopPropagation()}
                    _hover={{filter: 'brightness(0.95)'}}
                    _active={{transform: 'scale(0.98)'}}
                >
                    {label} · {score}
                </Badge>
            </PopoverTrigger>
            <PopoverContent w="340px" boxShadow="lg" zIndex={30}>
                <PopoverArrow/>
                <PopoverHeader fontWeight="bold" borderBottomWidth="1px" px={4} py={3}>
                    <Flex justify="space-between" align="center" gap={3}>
                        <Text fontSize="sm">Risk score: {score} / 100</Text>
                        <Flex align="center" gap={2}>
                            <Badge colorScheme={color} borderRadius="full" px="2" fontSize="0.65em">
                                {label.toUpperCase()}
                            </Badge>
                            <PopoverCloseButton position="static" size="sm"/>
                        </Flex>
                    </Flex>
                </PopoverHeader>
                <PopoverBody>
                    {list.length === 0 ? (
                        <Text fontSize="sm" color="gray.500">
                            No matched risk factors. This order looks clean.
                        </Text>
                    ) : (
                        <Box>
                            {list.map((factor, i) => (
                                <Flex
                                    key={`${factor.code}-${i}`}
                                    align="flex-start"
                                    py={1.5}
                                    borderBottomWidth={i < list.length - 1 ? '1px' : 0}
                                    borderColor="gray.100"
                                >
                                    <Text
                                        minW="44px"
                                        fontSize="sm"
                                        fontWeight="bold"
                                        color={factor.weight >= 0 ? 'red.500' : 'green.500'}
                                    >
                                        {factor.weight > 0 ? `+${factor.weight}` : factor.weight}
                                    </Text>
                                    <Text fontSize="sm" color="gray.700">
                                        {factor.label}
                                    </Text>
                                </Flex>
                            ))}
                        </Box>
                    )}
                </PopoverBody>
            </PopoverContent>
        </Popover>
    )
}

export default RiskBadge
